import { render, staticRenderFns } from "./sendRoleClearRequest.vue?vue&type=template&id=701b9519&"
import script from "./sendRoleClearRequest.vue?vue&type=script&lang=js&"
export * from "./sendRoleClearRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('701b9519')) {
      api.createRecord('701b9519', component.options)
    } else {
      api.reload('701b9519', component.options)
    }
    module.hot.accept("./sendRoleClearRequest.vue?vue&type=template&id=701b9519&", function () {
      api.rerender('701b9519', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpOpsManager/components/sendRoleClearRequest.vue"
export default component.exports